// extracted by mini-css-extract-plugin
export default {"root":"eOluxC","spinnerRoot":"ta6XCa","spinnerPlaceholder":"rS8S5L"};